<template>

    <div>
        <v-card class="d-flex">
            <v-card min-width="75" max-width="75" :disabled="expired" :color="bgColor" tile flat dark width="70"
                    class="pa-3 align-self-center text-center font-weight-bold">
                {{game.day}}<br>
                {{game.month}}
            </v-card>

            <v-card :disabled="expired" tile flat class="px-3 align-self-center flex-grow-1">
                <h5 class="body-1 pt-3">{{game.title}}</h5>
                <p>
                    <small>Orario: {{game.hour}} / {{game.end_hour}}</small>
                    <br>
                    <small>Setup: {{game.setup}} <span v-if="game.other">/ {{game.other}}</span></small>
                    <br>
                </p>
            </v-card>

            <v-card v-if="!expired" tile flat class="px-3 align-self-center">
                <v-btn fab color="black" @click="echo('vote')">
                    <v-icon large color="white">mdi-checkbox-marked-circle-outline</v-icon>
                </v-btn>
            </v-card>
            <v-card v-else tile flat class="px-3 align-self-center">
                <v-btn :disabled="this.game.archived === 1" fab color="purple" @click="echo('vote')">
                    <v-icon large color="white">mdi-clipboard-text-search-outline</v-icon>
                </v-btn>
            </v-card>

            <v-menu v-if="isAdmin" bottom left>
                <template v-slot:activator="{ on, attrs }">
                    <v-card tile flat class="px-2 py-5 align-self-center" v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-card>
                </template>
                <action-menu :items="filterActionMenu" @echo="echo"
                ></action-menu>
            </v-menu>

        </v-card>

    </div>
</template>

<script>
    import actionMenu from '../actionMenu';

    export default {
        name: 'game-list',
        props: {
            game: Object | Array,
            isAdmin: {
                type: Boolean,
                default: false,
            }
        },
        components: {
            actionMenu
        },
        data: () => ({
            actionMenu: [
                {text: 'Modifica', icon: 'mdi-file-edit', action: 'edit'},
                {text: 'Elimina', icon: 'mdi-delete', action: 'delete'},
                {text: 'Archivia', icon: 'mdi-folder-zip', action: 'archive'},
                {text: 'Estrai', icon: 'mdi-folder-zip-outline', action: 'extract'},
            ],
        }),
        computed: {
            filterActionMenu() {
                if (!this.expired && !this.game.archived) {
                    return this.actionMenu.filter(menu => {
                        return menu.action !== 'extract';
                    })
                }
                if (!this.expired && this.game.archived) {
                    return this.actionMenu.filter(menu => {
                        return menu.action === 'delete' || menu.action === 'extract';
                    })
                }
                if (this.expired && !this.game.archived) {
                    return this.actionMenu.filter(menu => {
                        return menu.action === 'delete' || menu.action === 'archive';
                    })
                }
                if (this.expired && this.game.archived) {
                    return this.actionMenu.filter(menu => {
                        return menu.action === 'delete';
                    })
                }
            },
            expired() {
                let now = new Date();
                let d = new Date(this.game.expiry_date + 'T' + this.game.expiry_time);
                return (now > d || (now === d && now.getHours() >= d.getHours() && now.getMinutes() > d.getMinutes()));
            },
            bgColor() {
                let color = {allenamento: '#1e7e34', evento: '#ff5333', amichevole: '#e0a609', altro: '#5f9ea0'}
                if (this.expired) {
                    return '#CCC';
                }
                return color[this.game.type];
            },
            /*getDay() {
                let d = new Date(this.game.date);
                return d.getDay();
            },
            getMonth() {
                let month = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic']
                let d = new Date(this.game.date);
                return month[d.getMonth()]
            },*/
        },
        methods: {
            echo(action) {
                this.$emit(action, this.game.container_id)
            }
        }
    }
</script>